import Vue from "vue"
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue"

Vue.component(FeatherIcon.name, FeatherIcon)
